import * as styles from "./ScrollAreaViewport.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { ScrollArea as BaseScrollArea } from "@base-ui/react/scroll-area";

import type { ScrollAreaViewportProps } from "./ScrollArea.types";

export function ScrollAreaViewport({
  className,
  fade,
  ...props
}: ScrollAreaViewportProps): JSX.Element {
  return (
    <BaseScrollArea.Viewport
      data-slot="scroll-area-viewport"
      className={clsx(
        styles.viewport,
        fade && styles.fade[true === fade ? "both" : fade],
        className,
      )}
      {...props}
    />
  );
}
